import React, { useCallback } from "react";

export type TalkToChrisModalProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onOpenUrgent: () => void;
};

export interface UseTalkToChrisModalResult {
    handleUrgentClick: () => void;
    handleOverlayClick: () => void;
    handlePointerDownOutside: (event: any) => void;
    handleContentClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const useTalkToChrisModal = ({
    open: _open, // intentionally unused, modal is controlled from parent
    onOpenChange,
    onOpenUrgent,
}: TalkToChrisModalProps): UseTalkToChrisModalResult => {
    const handleUrgentClick = useCallback(() => {
        onOpenChange(false);
        onOpenUrgent();
    }, [onOpenChange, onOpenUrgent]);

    const handleOverlayClick = useCallback(() => {
        onOpenChange(false);
    }, [onOpenChange]);

    const handlePointerDownOutside = useCallback(
        (_event: any) => {
            onOpenChange(false);
        },
        [onOpenChange],
    );

    const handleContentClick = useCallback(
        (event: React.MouseEvent<HTMLDivElement>) => {
            if (event.target === event.currentTarget) {
                onOpenChange(false);
            }
        },
        [onOpenChange],
    );

    return {
        handleUrgentClick,
        handleOverlayClick,
        handlePointerDownOutside,
        handleContentClick,
    };
};
